import { render, staticRenderFns } from "./CompanyIntro.vue?vue&type=template&id=9c25f198&scoped=true&"
import script from "./CompanyIntro.vue?vue&type=script&lang=js&"
export * from "./CompanyIntro.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIntro.vue?vue&type=style&index=0&id=9c25f198&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c25f198",
  null
  
)

export default component.exports